export default {
  'menu.welcome': 'Welcome',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  'menu.console': 'Admin',
  'menu.console.sub-page': 'Sub-Page',
  'menu.login': 'Login',
  'menu.register': 'Register',
  'menu.register-result': 'Register Result',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.settings': 'Account Settings',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.account.profile': 'Profile',
  'menu.console.agents': 'agents',
  'menu.console.agentDevice': 'agentDevice',
  'menu.console.devices': 'devices',
  'menu.console.speakers': 'Speaker Recognition',
  'menu.console.voiceClone': 'Voice Clone',
  'menu.console.settings': 'Personal Settings',
  'menu.admin': 'Admin',
  'menu.admin.dashboard': 'Dashboard',
  'menu.admin.settings': 'Settings',
  'menu.admin.providers': 'Model Providers',
  'menu.admin.unbindDevice': 'Device Unbind',
  'menu.admin.userManage': 'User Management',
  'menu.admin.systemConfig': 'System Config',
  'menu.admin.whiteList': 'Whitelist',
  'menu.admin.opsManage': 'Operations',
  'menu.admin.recorderManage': 'Recorder Management',
  'menu.admin.deviceManage': 'Device Management',

  'menu.console.agentSetting': 'Agent Settings',
};
